import { createApi } from "@reduxjs/toolkit/query/react";
import { DateFilter } from "shared/types/filters";
import { baseAppQuery } from "shared/api/baseQuery";
import { formatDateUi } from "shared/utils/converters";
import { snackbarOnQueryStarted } from "middleware/snackbarOnQueryStarted";

const ENDPOINT = "/analytical-report";
const analyticalReportApi: any = createApi({
    reducerPath: "analyticalReportApi",
    baseQuery: baseAppQuery,
    keepUnusedDataFor: 0,
    refetchOnMountOrArgChange: true,
    tagTypes: [ "analyticalReport"],
    endpoints: (builder) => ({
        getAnalyticalReport: builder.query<string, DateFilter>({
            query: (filter) => {
                const queryParams = new URLSearchParams();
                queryParams.set("from", formatDateUi(filter?.dateFrom ));
                queryParams.set("to", formatDateUi(filter?.dateTo));
                return {
                    url: `${ENDPOINT}/notice-disbursement?${queryParams}`,
                    responseHandler: (response) => response.blob().then((blob) => blob),
                }
            },
            providesTags: ["analyticalReport"],
            onQueryStarted: snackbarOnQueryStarted({
                errorMessage:"Не удалось запросить отчет по установленным датам",
            })
        }),
    }),
});

export const {
    useLazyGetAnalyticalReportQuery,
} = analyticalReportApi;
export default analyticalReportApi;
